import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetUserById = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_USER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetUserAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUserById as SetGetUserById
}